import { call, takeEvery,  all, put } from 'redux-saga/effects'
import { successfulLogin,failedLogin , successfulLogout, resetData} from './action'
import axios from 'axios';
import { handlError, parseError } from '../../app/serverError'
import {URL} from '../../../store/path'
import { parseJwt } from '../../../utilities/parseJWT'

//#region Saga for Request Login 
function* login() {
    yield takeEvery('LOGIN_REQUEST',requestLogin)
  }

function* requestLogin(action){
  yield put (resetData())
  const { response, error } = yield call(requestLoginAPI, action.payload)
  if (response) {
    console.log('response--------',response)
    let token_data = parseJwt(response.data.token)
    let menu_list = (response.data.menus && response.data.menus !== undefined && response.data.menus !== null ? response.data.menus : "")
    yield put (successfulLogin({
      username: action.payload.user,
      uid: token_data.uid
    }))
    yield localStorage.setItem('user', response.data.token);
    yield localStorage.setItem('userName', action.payload.user);
    yield localStorage.setItem('uid', token_data.identity);
    yield localStorage.setItem('exp', token_data.exp);
    yield localStorage.setItem('menu_permission', menu_list);
  }
  else {
    yield put (failedLogin({
      username: action.payload.user,
      //error_code: error.response.status,
      http_error: error.message,
      //error_message: error.response.data
    }))
  }
}

function requestLoginAPI(data) {
    console.log('login request sent', data);
    return axios.post(URL+'/users/login', {}, {
      crossDomain: true,
      headers: {'X-RLB-DMS-ACC': data.acc},  
      auth: {
        username: data.user,
        password: data.password
      }})
      .then(response => ({ response }))
      .catch(error => ({ error }))
  }

//#endregion


function* logout() {
  yield takeEvery('LOGOUT_REQUEST',requestLogout)
}

function* requestLogout(action) {
  yield localStorage.clear()
  yield localStorage.removeItem('user');
  yield localStorage.removeItem('acc');
  yield localStorage.removeItem('exp');
  yield localStorage.removeItem('userName');
  yield localStorage.removeItem('uid');
  yield localStorage.removeItem('menu_permission');
  yield put (resetData())
  yield put (successfulLogout({
    msg: 'Log out Successful'
  }))
}


const sagaErrorMessage = (error, action) => {
    console.group("Saga Error:"+action.type)
    console.log(error)
    console.groupEnd()
}

export default function* loginSaga() {
    yield all([
      login(),
      logout()
    ])
  }  